import React, { useState } from 'react';
import Text from '@molecules/Text';
import { BELoadingButton } from '@molecules/Button/Button';
import ModalComponent, { ModalProps } from '@molecules/BEOffScreen/Modal';
import { useTranslation } from 'react-i18next';
import { Flex, Checkbox } from '@chakra-ui/react';
import { withStore } from '@data/other/withStore';
import { StoreProps } from '@data/stores/Store';

type ModalCancelationPolicyProps = {
  onAgree: () => Promise<void>;
};

const ModalCancelationPolicy = ({
  store: { property },
  onAgree,
  ...modalProps
}: ModalProps & StoreProps & ModalCancelationPolicyProps) => {
  const { t } = useTranslation();
  const [agreed, setAgreed] = useState(false);

  return (
    <ModalComponent
      {...modalProps}
      title={t('cancelation-policy')}
      buttons={(props) => (
        <Flex direction="column" gap="24px" width="100%">
          <Checkbox
            isChecked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          >
            {t('read-and-agreed-to-terms-and-conditions')}
          </Checkbox>
          <BELoadingButton
            onClick={async () => {
              await onAgree();
              props.onOk?.();
            }}
            isDisabled={!agreed}
            color="primary"
          >
            {t('confirm-and-complete-booking')}
          </BELoadingButton>
        </Flex>
      )}
    >
      <Text html={property.model?.cancellationPolicy?.getText() || ''} />
    </ModalComponent>
  );
};

export default withStore(ModalCancelationPolicy);
